/* EMPRICS family data and icon strips v1.0 (26/10/26)
   Loads assets/emprics-families.json once per page (family title, category, code counts, icon selection from the
   product guide engine) and the public site-guides endpoint (current product guide PDF per family, photometric file
   counts). Renders the approved EMPRICS icon set v1.1 (David's leaf ring) as inline SVG strips.
   window.EmpricsData.ready() -> Promise<{ fam(code), list(), icons, guides, ldt, codes }>
   window.EmpricsData.strip(ids, { captions, cls }) -> HTML string */
(function () {
  'use strict';
  if (window.EmpricsData) return;
  var script = document.currentScript;
  var DATA_URL = (script && script.dataset.families) || window.EMPRICS_FAMILIES_URL;
  var GUIDES_URL = (script && script.dataset.guides) || 'https://glbfybjrzlzjxgezzfqh.supabase.co/functions/v1/site-guides';
  var promise = null;

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function ready() {
    if (promise) return promise;
    var fams = fetch(DATA_URL).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); });
    var guides = fetch(GUIDES_URL).then(function (r) { return r.ok ? r.json() : { guides: {}, ldt: {}, codes: {} }; })
      .catch(function () { return { guides: {}, ldt: {}, codes: {} }; });
    promise = Promise.all([fams, guides]).then(function (res) {
      var d = res[0], g = res[1] || {}, byCode = {}, list = [];
      d.families.forEach(function (r) {
        var o = { code: r[0], prefix: r[1], category: r[2], title: r[3], codes: r[4], accessories: r[5], cover: r[6], spec: r[7] };
        byCode[o.code] = o; list.push(o);
      });
      return {
        fam: function (c) { return byCode[String(c || '').toUpperCase()] || null; },
        list: function () { return list; },
        icons: d.icons,
        guides: g.guides || {},
        ldt: g.ldt || {},
        codes: g.codes || {}
      };
    });
    return promise;
  }

  function strip(icons, ids, opts) {
    opts = opts || {};
    var html = (ids || []).filter(function (i) { return icons[i]; }).map(function (i) {
      var lab = icons[i][0];
      return '<figure class="eic" title="' + esc(lab) + '"><span class="eic__svg" aria-hidden="true">' + icons[i][1] + '</span>' +
        (opts.captions === false ? '' : '<figcaption>' + esc(lab) + '</figcaption>') + '</figure>';
    }).join('');
    return html ? '<div class="eic-strip ' + (opts.cls || '') + '" role="list" aria-label="Key features">' + html + '</div>' : '';
  }

  window.EmpricsData = { ready: ready, strip: function (ids, opts) {
    return ready().then(function (D) { return strip(D.icons, ids, opts); });
  }, stripSync: strip, esc: esc };
})();
